<template>
  <div class="select-text">
    <TextLink
      class="text-link"
      v-for="(item, index) in itemList"
      :key="index"
      :text=item
      @click-text="onClick"
    />
  </div>
</template>

<script>
import TextLink from '@/components/Atoms/TextLink'

export default {
  name: 'select-text',
  components: {
    TextLink
  },
  props: {
    text: { type: String },
    itemList: { type: Array }
  },
  methods: {
    onClick (e) {
      this.$emit('select-text', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.text-link {
    font-weight: bold;
    margin: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Molecules/SelectText.vue